const header_nav_ul = document.querySelector('.header_nav_ul');

// header_nav_ul && header_nav_ul.querySelectorAll('.header_nav_li').forEach((li) => {
//   li.addEventListener('mouseenter', () => {
//     header_nav_ul.querySelector('.active').classList.remove('active');
//     li.classList.add('active');
//   });
// });

header_nav_ul && header_nav_ul.querySelectorAll('.header_nav_li').forEach((li) => {
  li.addEventListener('click', () => {
    header_nav_ul.querySelector('.active').classList.remove('active');
    li.classList.add('active');
  });
});


document.querySelectorAll('.view-more').forEach((view_more) => {
  view_more.addEventListener('click', () => {
    document.querySelectorAll('.header_nav_li.active .submenu_list li:not(.view-more)').forEach((li) => {
      let computedStyle = window.getComputedStyle(li)
      if (computedStyle.display === 'none') {
        li.style.display = 'block';
      } else {
        li.style.display = 'none';
      }
    });
    if (view_more.classList.contains('view-active')) {
      console.log("if");
      document.querySelector('.header_nav_li.active .submenu_list').insertAdjacentElement('beforeend', view_more);
      view_more.classList.remove('view-active');
      view_more.querySelector('.svg_right').classList.remove('js-hidden');
      view_more.querySelector('.svg_left').classList.add('js-hidden');
    } else {
      console.log("else");
      document.querySelector('.header_nav_li.active .submenu_list').insertAdjacentElement('afterbegin', view_more);
      view_more.classList.add('view-active');
      view_more.querySelector('.svg_right').classList.add('js-hidden');
      view_more.querySelector('.svg_left').classList.remove('js-hidden');

    }
  });

});
